import BaseEventModel from './base-event-model';

/** Represents a data model of the "Checkout Funnel" event. */
export class CheckoutFunnelEvent extends BaseEventModel {
  constructor(
    public readonly eventName: string,
    public readonly timestamp: number,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly merchantId: string,
    public readonly shopperCountryCode: string,
    public readonly category: string,
    public readonly cdn: string,
    public readonly checkoutToken: string,
    public readonly data: object,
    public userAgent?: string,
    public utmSource?: string,
    public utmMedium?: string,
    public utmCampaign?: string,
    public utmTerm?: string,
    public utmContent?: string,
    public utmAdSet?: string,
    public borderfreeProperties?: object,
    public isConsentGranted?: boolean,
  ) {
    super(eventName, timestamp, clientId, sessionId, merchantId, shopperCountryCode, category, cdn);
  }
}
